/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as AgeassuranceDefs from './defs.defs'

const $nsid = 'app.bsky.ageassurance.begin'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  email: /*#__PURE__*/ l.string(),
  language: /*#__PURE__*/ l.string(),
  regionCode: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  countryCode: /*#__PURE__*/ l.string(),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.payload(
  'application/json',
  /*#__PURE__*/ l.ref<AgeassuranceDefs.State>(
    (() => AgeassuranceDefs.state) as any,
  ),
)

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Initiate Age Assurance for an account. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'InvalidEmail',
  'DidTooLong',
  'InvalidInitiation',
  'RegionNotSupported',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
